class BilledServiceComposite {
    public Qty: number;
    public Price: number;
    public ServiceNumber: string;
    public NameFr: string;
    public NameEn: string;
    public NameEs: string;
    public GST: number;
    public QST: number;
    public HST: number;
    public GenericTax: number;
    public HadQST: boolean;
    public HadGST: boolean;
    public HadHST: boolean;
    public HadGenericTax: boolean;
    public CostCenterId: string;

    public constructor(init?: Partial<BilledServiceComposite>) {
        Object.assign(this, init);
    }
}

export { BilledServiceComposite };
